import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import MemberEnrollments from "../components/MemberEnrollments";
import * as actions from "../actions/memberEnrollments";

const EnrollmentsContainer = (props) => <MemberEnrollments {...props} />;

const mapStateToProps = (state) => ({
  enrollments: state.memberEnrollments.enrollments,
  isProcessing: state.memberEnrollments.isProcessing,
  showSnackBar: state.memberEnrollments.showSnackBar,
  successMessage: state.memberEnrollments.successMessage,
  errorMessage: state.memberEnrollments.errorMessage,
  adminUser: state.user,
  page: state.memberEnrollments.page,
  limit: state.memberEnrollments.limit,
  hasNext: state.memberEnrollments.hasNext,
  total: state.memberEnrollments.total,
});

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(actions, dispatch),
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(EnrollmentsContainer);
